// client/src/components/NotificationBell.js
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  IconButton, Badge, Popover, Box, Typography, List, ListItemButton, ListItemText, Button, Divider,
} from '@mui/material';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { NotificationContext } from '../context/NotificationContext';

const timeAgo = (dateStr) => {
  const diffMs = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};

const NotificationBell = () => {
  const { notifications, unreadCount, markRead, markAllRead } = useContext(NotificationContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleClick = (notification) => {
    setAnchorEl(null);
    if (!notification.is_read) markRead(notification.id);
    if (notification.link) navigate(notification.link);
  };

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} aria-label="Notifications">
        <Badge badgeContent={unreadCount} color="secondary">
          <NotificationsOutlinedIcon />
        </Badge>
      </IconButton>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ width: 360, maxWidth: '90vw', maxHeight: '70vh', overflowY: 'auto' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1.5 }}>
            <Typography variant="subtitle1" fontWeight={700}>Notifications</Typography>
            {unreadCount > 0 && <Button size="small" onClick={markAllRead}>Mark all read</Button>}
          </Box>
          <Divider />
          {notifications.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ p: 3, textAlign: 'center' }}>
              Nothing yet — order updates, outbid alerts, and messages will show up here.
            </Typography>
          ) : (
            <List disablePadding>
              {notifications.map((n) => (
                <ListItemButton key={n.id} onClick={() => handleClick(n)} sx={{ bgcolor: n.is_read ? 'transparent' : 'action.hover' }}>
                  <ListItemText
                    primary={n.title}
                    secondary={<>{n.message}<br /><Typography component="span" variant="caption" color="text.disabled">{timeAgo(n.created_at)}</Typography></>}
                  />
                </ListItemButton>
              ))}
            </List>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default NotificationBell;
